export default [
    {
        path: '/online-preview/:code',
        name: 'OnlinePreview',
        meta: { title: 'Online-Preview' },
        component: () => import('../views/preview/online-preview.vue')
    }
]